<template>
    <card-table-search :fields="fields"
                       :actions="actions"
                       :items="items"
                       :custom-rendered="['imageExtension', 'proprietaire']"
                       :exportColumns="fields.filter(item => item.key !== 'imageExtension')"
                       class="table-body-lh-40"
                       title="Liste des livres">
        <template #title>
            Liste des livres
            <b-button pill variant="success" size="sm" class="ml-2" v-b-tooltip.hover="'Ajouter un livre'"
                      @click="editLivreModal(null)">
                <font-awesome-icon icon="plus"/>
            </b-button>
        </template>
        <template #imageExtension="slotProps">
            <img :src="thumbnailSrc(slotProps.row.item, 'livres')" alt="Image du jeu" class="thumbnail-object-image"/>
        </template>
        <template #proprietaire="slotProps">
            <user-name :user="slotProps.row.item.proprietaire" default-cluji/>
        </template>
    </card-table-search>
</template>

<script>
    import {thumbnailSrc} from '@/util/image';
    import {apiPath}      from '@/util/http';
    import {textUsername} from '@/util/text';
    import alert          from '@/util/alert';

    const CardTableSearch     = () => import('@/components/CardTableSearch');
    const AdminEditLivreModal = () => import('@/components/modals/AdminEditLivreModal');
    const DisplayLivreModal   = () => import('@/components/modals/DisplayLivreModal');
    const UserName            = () => import('@/components/UserName');

    export default {
        name: "AdminLivres",
        components: {CardTableSearch, UserName},
        data() {
            return {
                fields: [
                    {
                        key: 'imageExtension',
                        label: 'Image',
                        sortable: false
                    },
                    {
                        key: 'nom',
                        label: 'Nom',
                        sortable: true
                    },
                    {
                        key: 'auteur',
                        label: 'Auteur',
                        sortable: true
                    },
                    {
                        key: 'caution',
                        label: 'Caution',
                        sortable: true,
                        formatter: value => value ? value + ' €' : ''
                    },
                    {
                        key: 'proprietaire',
                        label: 'Propriétaire',
                        sortable: true,
                        formatter: value => value ? textUsername(value) : '' // Only used for export, it's customRendered
                    },
                    {
                        key: 'actions',
                        label: 'Actions'
                    }
                ],
                actions: [
                    {
                        key: 'action_display',
                        color: () => 'secondary',
                        icon: 'eye',
                        tooltip: 'Afficher',
                        handler: ({item}) => this.displayLivreModal(item)
                    },
                    {
                        key: 'action_edit',
                        color: () => 'info',
                        icon: 'pen',
                        tooltip: 'Éditer',
                        handler: ({item}) => this.editLivreModal(item)
                    },
                    {
                        key: 'action_delete',
                        color: () => 'danger',
                        icon: 'trash',
                        tooltip: "Supprimer",
                        handler: ({item}) => this.deleteLivre(item)
                    }
                ],
                items: []
            };
        },
        methods: {
            thumbnailSrc,
            loadData() {
                alert.loading();
                this.axios.get(apiPath('admin_list_livres'))
                    .then(response => this.items = response.data)
                    .catch(() => this.$toaster.error('Impossible de récupérer la liste des livres'))
                    .finally(() => alert.stopLoading());
            },
            displayLivreModal(livre) {
                this.$store.dispatch('modal/create', {
                    component: DisplayLivreModal,
                    props: {livre: livre}
                })
            },
            editLivreModal(livre) {
                this.$store.dispatch('modal/create', {
                    component: AdminEditLivreModal,
                    props: {livre: livre, callback: () => this.loadData()}
                })
            },
            deleteLivre(livre) {
                alert.confirm('Supprimer le livre ' + livre.nom + ' ?', () => {
                    this.axios.delete(apiPath('admin_delete_livre', {livre: livre.id}))
                        .then(response => {
                            this.$toaster.success('Livre ' + (response.data.softDelete ? 'archivé' : 'supprimé') + ' avec succès');
                            this.loadData();
                        })
                        .catch(() => this.$toaster.error('Impossible de supprimer le livre'));
                });
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>
    .thumbnail-object-image {
        max-width: 40px;
        max-height: 40px;
    }
</style>
